import moment from "moment";
import { isDateClosedOutForRoom } from "../../modules/isDateClosedOutForRoom";

export const AvailabilityManagement = (props) => {
  const {
    dateColumns,
    currentMonth,
    selectedYear,
    availability,
    closeout,
    handleCellClick,
    roomId,
    maxcount,
  } = props;
  return (
    <tr>
      <td className="sticky-column">
        <strong>Availability</strong>
      </td>
      {dateColumns.map((date) => {
        const day = moment(date, "DD MMM").date();
        const dateKey = moment(
          `${day}-${currentMonth.month() + 1}-${selectedYear}`,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");
        const rawAvailability = availability?.[roomId]?.[dateKey];
        const availabilityForDate =
          typeof rawAvailability === "undefined" ? maxcount : rawAvailability;

        const isClosedOut =
          closeout[roomId]?.[dateKey]?.all || rawAvailability === 0;
        return (
          <td
            key={`${roomId}-${date}-availability`}
            className={`availability-cell ${isClosedOut ? "closed-out" : ""}`}
            onClick={
              !isClosedOut ? () => handleCellClick(roomId, dateKey) : undefined
            }
            style={{
              cursor: isClosedOut ? "not-allowed" : "pointer",
              backgroundColor: isDateClosedOutForRoom(roomId, dateKey, closeout)
                ? "#f4e736"
                : "transparent",
            }}
          >
            <div className="availability-box">
              {isClosedOut ? "Closed" : availabilityForDate}
            </div>
          </td>
        );
      })}
    </tr>
  );
};
